<template>
    <div>
        <div class="form-group">
            <legend>Kost</legend>
            <ul class="types--list types--list-without row" v-if="tags.length > 0">
                <li v-for="tag in tags" class="">
                    <label
                        class="form-control types--list-option"
                        v-bind:class="{
                            'is-selected':
                                selectedIdsInput.length > 0 && selectedIdsInput.indexOf(tag.id) != -1
                        }"
                    >
                        <input type="checkbox" name="tags[]" :value="tag.id" v-model="selectedIdsInput" />
                        <span>{{ tag.title }}</span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        preSelectedIds: {
            type: Array,
            default: () => []
        },

        preSelectedTitles: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            tags: {},
            selectedIdsInput: []
        };
    },

    mounted() {
        this.getTags();
        this.selectedIdsInput = this.preSelectedIds;
    },

    methods: {
        getTags() {
            axios.get('/recept/api/tags').then((response) => {
                this.tags = response.data;
            });
        }
    }
};
</script>
